import React from "react";
import QRCode from "qrcode.react";
import TextField from "material-ui/TextField";
import { Paper, RaisedButton } from "material-ui";
class URLQrCode extends React.Component {
  constructor(props) {
    super(props);
    this.download = this.download.bind(this);
  }

  download() {
    const link = this.link;
    const canvas = this.qrRef._canvas;
    console.log({ canvas });
    link.setAttribute("download", "QRCode.png");
    link.setAttribute(
      "href",
      canvas.toDataURL("image/png").replace("image/png", "image/octet-stream")
    );
    link.click();
  }

  render() {
    const { url, label } = this.props;

    return (
      <div>
        <a
          id="link"
          ref={(node) => {
            this.link = node;
          }}
        />
        <TextField
          label={label}
          value={url}
          fullWidth
          floatingLabelText={label}
        />
        <QRCode
          value={url}
          size={256}
          level={"L"}
          includeMargin={true}
          renderAs={"svg"}
          ref={(node) => {
            this.qrRef = node;
          }}
        />
        <br />
        <RaisedButton label="Download" onClick={this.download} primary />
      </div>
    );
  }
}

export default URLQrCode;



// WEBPACK FOOTER //
// ./src/components/URLQrCode.js